(function($){

    $(document).ready(function(){
        initOfferBox();

        $(document).on('scrollToHash', scrollToHash);
    });

    $(window).resize(function(){
        $('.context-description__expand-area').each(function () {
            var area = $(this);

            if (parseInt(area.css('max-height'))) {
                area.css('max-height', area.prop('scrollHeight') + 'px');
            }
        });
    });

    function initOfferBox() {
        if (!$('.content-box--offer').length) {
            return;
        }

        var $expand = $('.context-description__expand');
        $expand.on('click', toggle);
        $expand.on('keydown', function(event) {
            if (event.which === 13) {
                $(this).trigger('click');
            }
        });
    }

    function toggle(event) {
        var $this = $(this),
            container = $this.closest('.content-box--offer'),
            area = container.find('.context-description__expand-area');

        $this.toggleClass('context-description__expand--expanded');

        if (parseInt(area.css('max-height'))) {
            // close area
            area.css('max-height', '0px');
            $this.attr('aria-expanded', 'false');
            $this.focus();
        } else {
            // open area
            area.css('max-height', area.prop('scrollHeight') + 'px');
            $this.attr('aria-expanded', 'true');
            area.find('.context-description__note-wrapper').focus();
        }
    }

    function scrollToHash(event, hash) {
        var $expand = $(hash).find('.context-description__expand:visible');

        if ($expand.length && $expand.attr('aria-expanded') === 'false') {
            $expand.trigger('click');
        }
    }
}(jQuery));
